import { memo } from "react";
import { FormattedMessage, useIntl } from "react-intl";

type PasswordInputProps = {
  id: string;
  value: string;
  onChange: (id: string, value: string) => void;
  label: { id: string };
  placeholder: { id: string };
  errors: string[];
  showValidationMessage?: boolean;
  onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void;
};

export const PasswordInput = memo(
  ({
    id,
    value,
    onChange,
    label,
    placeholder,
    errors,
    showValidationMessage,
    onBlur,
  }: PasswordInputProps) => {
    const intl = useIntl();

    return (
      <div className="text__input--row">
        <div className="text-input">
          {label && (
            <label className="text-input__label" htmlFor={id}>
              <FormattedMessage id={label.id} />
            </label>
          )}
          <input
            type="password"
            id={id}
            value={value}
            onChange={e => onChange(id, e.target.value)}
            placeholder={intl.formatMessage({ id: placeholder.id })}
            className={`text-input__input ${errors.length > 0 ? "error" : ""}`}
            onBlur={onBlur}
          />
        </div>
        <div className="validation__message">
          {errors.length > 0
            ? errors.map((error, index) => (
                <span className="error-msg" key={index}>
                  {error}
                </span>
              ))
            : showValidationMessage && (
                <FormattedMessage
                  tagName="span"
                  id="password-validation-message"
                />
              )}
        </div>
      </div>
    );
  }
);
